<div class="toolbox-component" id="image-edit">
  @if (isMobileDevice) {
    <div class="header">
      <div class="header-title">
        <span class="header-title-main">
          {{ 'i18n.toolbox.imageEdit.title' | translate }}
        </span>
      </div>
      <mat-icon svgIcon="close"
        class="close-x"
      (click)="btnCloseClick()"></mat-icon>
    </div>
  }
  <div class="content">
    @if (isMobileDevice) {
      <div class="action-button"
           (click)="toolboxService.open('ImageToolbox')">
        <mat-icon svgIcon="crop"></mat-icon>
        {{ 'i18n.button.cropImage' | translate }}
      </div>
      <div class="action-button" (click)="resetPlaceholder()">
        <mat-icon svgIcon="photo-remove"></mat-icon>
        {{ 'i18n.toolbox.imageEdit.removeImageMobile' | translate }}
      </div>
      <div class="action-button"
           (click)="toolboxService.open('GalleryToolbox')">
        <mat-icon svgIcon="replace"></mat-icon>
        @if (isMobileDevice) {
          {{ 'i18n.toolbox.imageEdit.swapImage' | translate }}
        }
      </div>
    }

    @if (!isMobileDevice) {
      <div class="image-edit-tools">
        <image-zoom></image-zoom>
        <image-rotate></image-rotate>
      </div>
      <div class="spacer"></div>
      <div class="action-button remove-photo-button"
           (click)="resetPlaceholder()">
        <mat-icon svgIcon="photo-remove"></mat-icon>
        <span class="remove-photo-label">
          {{ 'i18n.toolbox.imageEdit.removeImageDesktop' | translate }}
        </span>
      </div>
      <div class="spacer"></div>
      <mat-icon svgIcon="close"
        class="close-x"
      (click)="btnCloseClick()"></mat-icon>
    }
  </div>
</div>
